import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const userDetailAction = createAsyncThunk(
    'user-detail',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/user/details`,{user_id:data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userDetailSlice = createSlice({
    name: 'user-detail',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userDetailAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userDetailAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(userDetailAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const userDetailReducer = userDetailSlice.reducer